import * as setting from '../../package.json';
const appSetting = setting;
export const environment = {
  production: false,
  settings: {
    api_url: 'https://api-planetact.dev.eliorgroup.com',
    api_version: 'v1',
  },
  appVersion: appSetting.version + '--dev',
  adAuth: {
    enabled: false,
    clientId: '018f6559-f493-44dd-bdd4-6b308df38f45',
    authority:
      'https://login.microsoftonline.com/0e3d950c-f028-43ec-963b-c060275e6bbc/',
    redirectUri: 'https://app-planetact.dev.eliorgroup.com',
    apiScopeUrl: [`api://018f6559-f493-44dd-bdd4-6b308df38f45/user.read`],
  },
};
